import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const DashboardContainer = styled.div`
  background: #ffffff;
  margin: 0 auto;
  max-width: 1130px;
  @media (max-width: 1150px) {
    padding: 0 20px;
  }
  h1 {
    font-weight: 700;
    font-size: 19px;
    line-height: 23px;
    letter-spacing: 0.4px;
    color: ${({ theme }) => theme.accent};
    margin-top: 42px;
  }
`;

export const DashboardListContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px;
  margin: 61px 0 20px;
  @media (max-width: 1150px) {
    align-items: center;
    border: none;
  }
  h3 {
    margin-bottom: 49px;
    font-weight: 700;
    font-size: 19px;
    line-height: 23px;
    letter-spacing: 0.4px;
    color: ${({ theme }) => theme.black};
  }
  ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 51px;
    @media (max-width: 1150px) {
      justify-content: center;
    }
  }
`;

export const ContractItem = styled.li`
  display: flex;
  flex-direction: column;
  width: 320px;
  height: 354px;
  border: 1px solid #dfe0eb;
  border-radius: 8px;
  padding: 30px 32px;
`;

type StatusProps = {
    color: string;
};

export const Status = styled.span<StatusProps>`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 5px 12px;
  border-radius: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  text-transform: uppercase;
  color: #ffffff;
  letter-spacing: 0.5px;
  background: ${({ color }) => color};
`;

export const EmployeeInfoContainer = styled.div`
  margin: 29px 0 10px;
  display: flex;
  gap: 19px;
  img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
  }
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    strong {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0.2px;
      color: #252733;
    }
    span {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.1px;
      color: ${({ theme }) => theme.gray};
    }
  }
`;

export const EmployeeLocationContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 7px;
  span {
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.grayLight} !important;
  }
`;

export const ContractInfoContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  strong {
    font-weight: 700;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.black};
  }
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.gray};
  }
`;

export const DetailsLink = styled(Link)`
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  padding: 15px 24px 13px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.accent};
  text-transform: capitalize;
  border-radius: 31px;
  border: 1px solid ${({ theme }) => theme.accent};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.blueDark};
    border-color: ${({ theme }) => theme.blueDark};
  }
`;

export const EmployeeInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  small {
    display: none;
  }
  img{
    margin-right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
      display: none;
    }
  }
  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    flex-direction: column;
    align-items: start;
    justify-content: center;
    small{
      display: flex;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.1px;
      color: ${({theme}) => theme.grayDark}
    }
  }
`
export const EmployeeIdentification = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  img {
    margin-right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
      display: none;
    }
  }

  h3 {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${({theme}) => theme.accent};
  }

  h4 {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.1px;
    color: ${({theme}) => theme.grayDark};
  }
`

export const EmployeeAddress = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: start;
  justify-content: space-between;
  
  @media (max-width: ${({theme}) => theme.breakpoints.xxl}) {
    align-items: center;
    justify-content: center;
  }
  
  h3{
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${({theme}) => theme.accent};
    @media (max-width: ${({theme}) => theme.breakpoints.xxl}) {
      display: none;
    }
  }
`

interface EmployeeCountryProps {
    countryName: string;
    countryCode: string
}

export const EmployeeCountry = styled.div<EmployeeCountryProps>`
    width: 100% ;
    display: flex;
    justify-content: start;
    align-items: center;
    h6{
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.1px;
      color: ${({theme}) => theme.grayLight};
      
      &::after{
        content: "${({countryName}) => countryName}";
      }
      
      @media (max-width: ${({theme}) => theme.breakpoints.md}) {
        &::after{
          content: "${({countryCode}) => countryCode}";
        }
      }
   
    }
`

export const RegisterEmployee = styled.button`
  display: flex;
  margin: 0 auto;
  align-items: center;
  padding: 10px 24px;
  white-space: nowrap;
  background: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.grayLight};
  color: ${({theme}) => theme.gray};
  font-weight: 500;
  font-size: 14px;
  border-radius: 30px;
  transition: all 300ms ease-in-out;
  svg{
    path{
      transition: all 300ms ease-in-out;
    }
  }
  span{
    margin-right: 20px;
  }
  :hover{ 
    border-color: ${({ theme }) => theme.accent};
    color: ${({ theme }) => theme.accent};
    svg{
      path{
        stroke: ${({ theme }) => theme.accent};
      }
    }
  }
  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    svg{
      display: none;
    }
    span{
      margin-right: 0;
    }
    font-size: 10px;
    padding: 10px 12px;
    white-space: break-spaces;
  }
`
export const TaxInfo = styled.div`
    h3 {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.1px;
      color: ${({theme}) => theme.grayDark};
    }
`
